import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { hitApi, commonToast } from "../../../components/commonAction";
import BillingTabs from "./BillingTabs";

const FIELDS = [
    { key: "globalCommissionRate",   label: "Global commission rate (0–1)",          step: "0.01" },
    { key: "cookieDurationDays",     label: "Referral cookie duration (days)",       step: "1" },
    { key: "commissionHoldbackDays", label: "Commission holdback before payout-eligible (days)", step: "1" },
    { key: "minimumPayoutAmount",    label: "Minimum payout amount",                 step: "1" },
    { key: "refundWindowDays",       label: "Refund window (days)",                  step: "1" },
    { key: "defaultCurrency",        label: "Default currency",                      type: "text" },
];

export default function Settings({ pageTitle }) {
    const [values, setValues] = useState(null);
    const [saving, setSaving] = useState(false);

    const load = () => {
        hitApi({ url: "admin/billing/settings", method: "GET", data: {}, alert: false }, (resp) => {
            if (resp?.status) setValues(resp.data?.settings || {});
        });
    };
    useEffect(load, []);

    const save = (e) => {
        e.preventDefault();
        if (!values) return;
        const body = {};
        FIELDS.forEach(f => {
            if (f.type === "text") body[f.key] = values[f.key];
            else body[f.key] = Number(values[f.key]);
        });
        setSaving(true);
        hitApi({ url: "admin/billing/settings", method: "PATCH", data: body }, (resp) => {
            setSaving(false);
            if (resp?.status) {
                commonToast("success", resp.message);
                setValues(resp.data?.settings || values);
            }
        });
    };

    return (
        <div className="pxl_rightBar_assets">
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl-rb-header-wrap"><div className="pxl-headingTop"><h2 className="pxl-rb-header-heading">Billing</h2></div></div>
            <BillingTabs />

            <div className="pxl-panel" style={{ maxWidth: 600 }}>
                <div className="pxl-panel-header">Billing settings</div>
                <div className="pxl-panel-body">
                    {!values ? (
                        <div className="text-muted">Loading…</div>
                    ) : (
                        <form onSubmit={save}>
                            {FIELDS.map(f => (
                                <div className="pxl_input_feilds pxl-input-compact" key={f.key}>
                                    <label>{f.label}</label>
                                    <input
                                        type={f.type || "number"}
                                        step={f.step}
                                        value={values[f.key] ?? ""}
                                        onChange={e => setValues({ ...values, [f.key]: e.target.value })}
                                    />
                                </div>
                            ))}
                            <button type="submit" className="pxlCommon-btn" disabled={saving}>
                                {saving ? "Saving…" : "Save"}
                            </button>
                            <small style={{ display: "block", color: "#8a8fa6", fontSize: 12, marginTop: 14 }}>
                                Stored in the <code>configs</code> collection under <code>name='billing'</code>.
                                Future phases (commission, payouts) read from this document.
                            </small>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
